import { useNavigate, useParams } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { ESPECIALIDADE_LABEL, type EspecialidadeProf } from "../../types";
import { dataCurta } from "../../lib/format";
import { arquivarProfissional, editarProfissional, getNotasDoProfissional, getProfissional } from "../queries";
import { ESPECIALIDADES_ORDEM } from "../types";
import { EspecialidadeBadge } from "../ui/EspecialidadeBadge";

export function DetalheProfissional() {
  const { id = "" } = useParams();
  const nav = useNavigate();
  const prof = useLiveQuery(() => getProfissional(id), [id]);
  const notas = useLiveQuery(() => getNotasDoProfissional(id), [id]) ?? [];

  if (!prof) {
    return (
      <main className="tela">
        <button className="btn btn-fantasma" onClick={() => nav(-1)}>← voltar</button>
        <div className="vazio">profissional não encontrado.</div>
      </main>
    );
  }

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>← voltar</button>

      <div className="row" style={{ marginBottom: "var(--s4)" }}>
        <div className="foto" aria-hidden style={{ width: 56, height: 56 }}>👤</div>
        <div className="crescer">
          <h1 className="tela-titulo" style={{ marginBottom: 4 }}>{prof.nome}</h1>
          {prof.registro_classe && <div className="meta" style={{ color: "var(--text-muted)" }}>{prof.registro_classe}</div>}
        </div>
        <EspecialidadeBadge especialidade={prof.especialidade} curto />
      </div>

      <button
        className="btn btn-primario btn-bloco btn-grande"
        style={{ marginBottom: "var(--s5)" }}
        onClick={() => nav(`/elo/registrar/${id}`)}
      >
        🔗 registrar sessão deste profissional
      </button>

      <section className="secao">
        <h2 className="secao-titulo">dados</h2>
        <div className="card">
          <div className="campo">
            <label>especialidade</label>
            <select
              value={prof.especialidade}
              onChange={(e) => editarProfissional(id, { especialidade: e.target.value as EspecialidadeProf })}
            >
              {ESPECIALIDADES_ORDEM.map((e) => (
                <option key={e} value={e}>{ESPECIALIDADE_LABEL[e]}</option>
              ))}
            </select>
          </div>
          <div className="campo">
            <label>registro de classe</label>
            <input
              type="text"
              value={prof.registro_classe ?? ""}
              onChange={(e) => editarProfissional(id, { registro_classe: e.target.value || null })}
              placeholder="CRFa / CREFITO / CRP / CRN"
            />
          </div>
          <div className="campo" style={{ margin: 0 }}>
            <label>contato</label>
            <input
              type="text"
              value={prof.contato ?? ""}
              onChange={(e) => editarProfissional(id, { contato: e.target.value || null })}
              placeholder="e-mail ou telefone"
            />
          </div>
        </div>
      </section>

      <section className="secao">
        <h2 className="secao-titulo">sessões registradas</h2>
        {notas.length === 0 ? (
          <div className="card" style={{ color: "var(--text-muted)" }}>nenhuma sessão ainda.</div>
        ) : (
          notas.map((n) => (
            <button className="card linha-alimento" key={n.id} onClick={() => nav(`/elo/nota/${n.id}`)}>
              <div className="crescer">
                <div className="nome">{n.objetivo}</div>
                <div className="meta">{dataCurta(n.data_sessao)}</div>
              </div>
              <span aria-hidden>→</span>
            </button>
          ))
        )}
      </section>

      <button
        className="btn btn-bloco"
        style={{ marginTop: "var(--s4)", color: "var(--text-muted)" }}
        onClick={async () => {
          await arquivarProfissional(id);
          nav("/elo/equipe", { replace: true });
        }}
      >
        arquivar profissional
      </button>
    </main>
  );
}
